import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyUiPopupComponent } from './component/popup/popup';
import { SkyUiNativeScrollModule } from '../native-scroll/module';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { SkyUiSimplePopupComponent } from './component/simple-popup/simple-popup';
import { SkyUiButtonModule } from '../button/module';
import { SkyUiIconModule } from '../icon/module';
import { SkyUiPopupService } from './service/popup';

@NgModule({
  imports: [CommonModule, PortalModule, OverlayModule, SkyUiNativeScrollModule, SkyUiButtonModule, SkyUiIconModule],
  providers: [SkyUiPopupService],
  declarations: [SkyUiPopupComponent, SkyUiSimplePopupComponent],
  exports: [SkyUiPopupComponent],
})
export class SkyUiPopupModule {}
